import { SelectOptionLocal } from '../types/common/commonTypes'
import { templateButton } from '../types/part/partTypes'

type TemplateData = {
    title?: string
    mark?: string
    model?: string
    modification?: string
    year?: string
    partNumber?: string
    condition?: string
}

interface IGetFilledTemplateButtonsParams {
    templateButtons: templateButton[]
    switchPosition: number
    carId?: string
    title?: string
    mark?: string
    model?: string
    modification?: string
    year?: string
    partNumber?: string
    condition?: string
    cars?: SelectOptionLocal[]
}

export const getFilledTemplateButtons = ({
    templateButtons,
    switchPosition,
    carId,
    title,
    mark,
    model,
    modification,
    year,
    partNumber,
    condition,
    cars,
}: IGetFilledTemplateButtonsParams): templateButton[] => {
    const applyTemplate = (template: string, data: TemplateData): string =>
        template.replace(/\[([^\]]+)\]/g, (_, key) => {
            const value = data[key as keyof TemplateData]
            return value ?? `[${key}]` // если данных нет — оставляем как есть
        })

    const currentCar = cars?.find(car => car.value === carId)

    const templateData: TemplateData = {
        title,
        partNumber,
        condition,
    }

    if (switchPosition === 2) {
        templateData.mark = mark
        templateData.model = model
        templateData.modification = modification
        templateData.year = year
    } else if (switchPosition === 1 && currentCar) {
        templateData.mark = currentCar.carData?.markTitle
        templateData.model = currentCar.carData?.modelTitle
        templateData.modification = currentCar.carData?.modificationTitle
        templateData.year = currentCar.carData?.year
    }

    return templateButtons.map(button => {
        if (!button?.value) return button

        return {
            ...button,
            value: applyTemplate(button.value, templateData),
        }
    })
}
